import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ValidationService } from "../../../services";
import { Counts } from "../../../services/webservice/access-codes-api.service";


@Component({
	selector: 'access-codes-presentation',
	templateUrl: "./access-codes.presentation.html",
	styleUrls: ["./access-codes.presentation.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class AccessCodesPresentation {
	@Input() showAccessCodesPopup: boolean;
	@Input() counts: Counts;
	@Output() cancelClicked = new EventEmitter<void>();
	@Output() generateCodesClicked = new EventEmitter<number>();
	@Output() downloadCodesClicked = new EventEmitter<string>();
	generateAccessCodesForm: FormGroup;

	public constructor(private formBuilder: FormBuilder) {
		this.createForm();
	}

	submitGenerateAccessCodesForm(formValues: any) {
		this.generateCodesClicked.emit(formValues.amount);
	}

	hideAccessCodesPopup() {
		this.resetForm();
		this.cancelClicked.emit()
	}

	private createForm() {
		this.generateAccessCodesForm = this.formBuilder.group({
			amount: ['', [ValidationService.positiveInteger, Validators.required]]
		});
	}

	private resetForm() {
		this.generateAccessCodesForm.reset();
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/price-form/access-codes/access-codes.presentation.ts